export const AvailabilitySettingsTrackingIds = {
  events: {
    availabilityPageViewed: 'availability-settings-page-viewed',
    availabilityTabSelected: 'availability-tab-selected',
    ruleConfigCancelClicked: 'rule-config-cancel-clicked',
    availabilityRuleSaveClicked: 'availability-rule-save-clicked',
    exceptionSaveClicked: 'exception-save-clicked',
    ruleDeleteClicked: 'rule-delete-clicked',
    changeAvailabilityModeClicked: 'change-availability-mode-clicked',
    availabilityModeConfirmChangeClicked: 'availability-mode-confirm-change-clicked',
  },
} as const;
